module.exports = __webpack_public_path__ + "static/media/Kuva_7_3.68b3edac.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_7_3.png
// module id = 1404
// module chunks = 0